import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/homePage'

Vue.use(VueRouter)

const routes = [
  { path: '/home', name: 'HomePage', component: HomePage },
  { path: '/login', name: 'LoginPage', component: () => import('@/views/loginPage') },
  { path: '/attachment', name: 'AttachmentPage', component: () => import('@/views/attachment') },
  { path: '/detail', name: 'DetailPage', component: () => import('@/views/detailPage') },
  { path: '/share', name: 'SharePage', component: () => import('@/views/sharePage'), meta: { title: 'Path Academics' } },
  { path: '/view', name: 'ViewPage', component: () => import('@/views/pdfView') },
  { path: '/jpgview', name: 'ViewPage', component: () => import('@/views/jpgView') },
  { path: '*', redirect: { name: 'HomePage' } }
]

const router = new VueRouter({ mode: 'history', routes })
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (from.path === '/view' && to.name === 'SharePage') {
    to.meta.isUpdate = true
  } else if (from.path !== '/view' && to.name === 'SharePage') {
    to.meta.isUpdate = false
  }
  if (to.meta.title) {
    document.title = to.meta ? to.meta.title : '小搜科研移动端'
  }
  next()
})
export default router
